import {Component, ViewChild} from '@angular/core';
import {DataTableComponent, Selectability, TableConfig} from '../../../components/data-table/data-table.component';
import {StringFilterComponent} from "../../../components/data-table/filters/string-filter/string-filter.component";
import {DateFilterComponent} from "../../../components/data-table/filters/date-filter/date-filter.component";
import {firstValueFrom} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {EmployeeDialogComponent} from "../dialog/employee-dialog.component";
import {NumberFilterComponent} from "../../../components/data-table/filters/number-filter/number-filter.component";
import {EmployeesV1Service, Employee, TaskType, Department} from "../../../apis/backend";
import {ListFilterComponent} from "../../../components/data-table/filters/list-filter/list-filter.component";
import {TaskTypeDialogComponent} from "../../tasks/type-dialog/task-type-dialog.component";
import {DepartmentDialogComponent} from "../department-dialog/department-dialog.component";
import {CredentialsDialogComponent} from "../credentials-dialog/credentials-dialog.component";
import {DataTableCellDirective} from "../../../components/data-table/cell/data-table-cell.component";

type FilterOption = {
  Value: string,
  Text: string
};

export const EmployeeConfig: TableConfig = {
  ODataResourceName: 'employees',
  Selectability: Selectability.SingleSelect,
  Columns: [
    {
      DisplayName: 'ID',
      PropertyName: 'PaycorID',
      FilterType: NumberFilterComponent,
      Formatter: (v, row) => {
        let ret = document.createElement('a');
        ret.href = '/employees/' + row['EmployeeID'];
        ret.target = '_blank';
        ret.innerText = v || 'N/A';
        return ret;
      }
    },
    {
      DisplayName: 'Username',
      PropertyName: 'Username',
      FilterType: StringFilterComponent
    },
    {
      DisplayName: 'First Name',
      PropertyName: 'FirstName',
      FilterType: StringFilterComponent
    },
    {
      DisplayName: 'Last Name',
      PropertyName: 'LastName',
      FilterType: StringFilterComponent
    },
    {
      DisplayName: 'Phone Number',
      PropertyName: 'PhoneNumber',
      FilterType: StringFilterComponent
    },
    {
      DisplayName: 'Departments',
      PropertyName: 'Departments',
      Formatter: (v: Department[]) => v.map(d => d.Name).join(', ')
    },
    {
      DisplayName: 'Start Date',
      PropertyName: 'StartDate',
      FilterType: DateFilterComponent,
      Formatter: (v) => new Date(v).toLocaleDateString()
    },
    {
      DisplayName: 'Last Day',
      PropertyName: 'EndDate',
      FilterType: DateFilterComponent,
      Formatter: (v) => v ? new Date(v).toLocaleDateString() : ''
    },
    {
      DisplayName: 'Birthday',
      PropertyName: 'BirthDate',
      FilterType: DateFilterComponent,
      Formatter: (v) => v ? new Date(v).toLocaleDateString() : ''
    },
    {
      DisplayName: 'Is Active',
      PropertyName: 'IsActive',
      Formatter: DataTableCellDirective.BooleanFormatter
    },
  ]
}

@Component({
  selector: 'employee-overview',
  templateUrl: './employee-overview.component.html',
})
export class EmployeeOverviewComponent {
  
  public TableConfig = EmployeeConfig;

  public Prefilters: FilterOption[] = [
    {
      Value: 'IsActive eq true',
      Text: 'Active Employees'
    },
    {
      Value: '',
      Text: 'All Employees'
    },
  ];
  
  public Prefilter: string;
  public Filter: string;
  
  @ViewChild(DataTableComponent)
  public DataTable: DataTableComponent;
  
  constructor(
      private _employeeService: EmployeesV1Service,
      private _modalService: NgbModal) {

    _employeeService.getDepartments().subscribe({
      next: (departments) => {
        this.TableConfig.Columns.find(c => c.PropertyName == 'Department').FilterInputs =
            departments.map(d => ({ Text: d.Name, Value: d.DepartmentID }));
      }
    });
  }
  
  ngOnInit() {
    this.Prefilter = this.Prefilters[0].Value;
  }

  public CreateEmployee() {
    this._modalService.open(EmployeeDialogComponent, { size: 'lg' }).result
        .then((employee: Employee) => {
          return firstValueFrom(this._employeeService.createEmployee(employee));
        })
        .then(() => {
          this.DataTable.Refresh();
        });
  }

  public EditEmployee(employee?: Employee) {
    if (!employee) {
      employee = this.DataTable.GetSelection();
    }
    if (employee) {
      employee = <Employee>JSON.parse(JSON.stringify(employee));
      let modal = this._modalService.open(EmployeeDialogComponent, { size: 'lg' });
      modal.componentInstance.Employee = employee;

      modal.result
          .then((employee: Employee) => {
            return firstValueFrom(this._employeeService.updateEmployee(employee.EmployeeID, employee));
          })
          .then(() => {
            this.DataTable.Refresh();
          });
    }
  }

  public SetCredentials() {
    let employee = <Employee>this.DataTable.GetSelection();
    if (employee) {
      let modal = this._modalService.open(CredentialsDialogComponent, { size: 'lg' });
      if (employee.Username) {
        modal.componentInstance.Username = employee.Username;
      }
      else {
        modal.componentInstance.EmployeeID = employee.EmployeeID;
      }

      modal.result
          .then(() => {
            this.DataTable.Refresh();
          });
    }
  }

  public ManageDepartments() {
    this._modalService.open(DepartmentDialogComponent, { size: 'lg' }).result
        .then(() => {
          this.DataTable.Refresh();
        });
  }
}
